import { createContext } from 'react'

interface AuthInterface {
  getting: boolean
  name: string
  authToken: string
  token: string
  clientId: string
  username: string
}

export default createContext<null | AuthInterface>(null)